import httpClient from '../httpClient';

const generateTemplateURL = async (data) => {
  return await httpClient.post(`/template/`, data);
};

export { generateTemplateURL };
